<template>
    <div
        v-loading="true"
        class="w-full h-full"
    />
</template>

<script>
import { defineComponent, onMounted } from 'vue';
import { loginWithGoogleCallback } from '@/store/auth';
import router from '@/router';

export default defineComponent({
    name: 'GoogleCallback',
    props: {
        query: {
            type: Object,
            default: () => ({}),
        },
    },
    setup (props) {
        onMounted(() => {
            loginWithGoogleCallback(props.query)
                .then(() => router.push({ name: 'Dashboard' }))
                .catch(() => {
                    router.push({ name: 'Login' });
                });
        });
    },
});
</script>